// extracted by mini-css-extract-plugin
export var aboutUsSection = "index-module--about-us-section--Clhvz";
export var contactInfo = "index-module--contact-info--52Svh";
export var contactInfoLeft = "index-module--contact-info-left--xICHS";
export var contactInfoRight = "index-module--contact-info-right--Wu4yG";
export var contactSection = "index-module--contact-section--9JGM8";
export var employeesInfo = "index-module--employees-info--df-Pj";
export var map = "index-module--map--js6sg";
export var selectedProjectsSection = "index-module--selected-projects-section--QoG9x";